import "./notesPage.css";
import axios from "axios";
import { useState, useEffect } from "react";

function NotesPage() {
  const [developerName, setDeveloperName] = useState(null);

  const getSearchParam = (param) => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(param);
  };

  const orgCode = getSearchParam("orgCode") || null;
  const devName = developerName
    ? developerName
    : "Bunch Microtechnologies Private Limited";

  const handle = async () => {
    try {
      const response = await axios.get(
        `https://api.classplusapp.com/su/organizations/publisherDetails?orgCode=${orgCode}`,
        {
          headers: {
            accessKey: "9MbcQUwu8UVA1kfcY4Smf9KK7hLvsf5s",
          },
        }
      );

      if (response?.status === 200) {
        setDeveloperName(response?.data?.data?.accountName);
      }
    } catch (error) {
      setDeveloperName(null);
      console.error("Error fetching organization details:", error);
    }
  };
  const updateText = `After you have provided the information above, please allow ${devName} {developer} up to 30 days to take the necessary action and respond. We urge you to send requests for any actions regarding your data through the email address associated with your account. ${devName} may need to verify your identity before implementing your request.`;
  useEffect(() => {
    handle();
  }, []);

  return (
    <div className="pageContainer">
      <div className="pageBox">
        <p className="notePageHeading">Mail to us</p>
        <ul>
          <li>
            To initiate the deletion of your profile and data, please send an
            email to <a href="mailto:accountdata@classplus.co">
              accountdata@classplus.co
            </a> containing the following
            information:
            <p>Registered Name</p>
            <p>Registered Mobile Number</p>
            <p>Registered Email Address</p>
            <p>Reason for deletion</p>
          </li>
          <li>
            Upon receiving your request, please allow {""}
            <span style={{ fontWeight: "600" }}>{devName}</span> ("Developer") up to 30
            days to process your request and respond accordingly. We encourage
            you to send all data-related requests through the email address
            linked to your account. {devName} ("Developer") may need to verify your
            identity before proceeding with your request.
          </li>
          <li>
            You may delete your account as well as your user data stored with
            Classplus by submitting the above details. Once your account is
            deleted, you will lose access to all services. For avoidance of
            doubt, it is hereby clarified that all data with respect to
            transactions on the Platform will be retained in accordance with
            applicable law.
          </li>
          <li>
            For any other issues, you can reach out to us at{" "}
            <a href="mailto:accountdata@classplus.co">
              accountdata@classplus.co
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default NotesPage;
